// extracted by mini-css-extract-plugin
export default {"base":"eDVot","card":"B9AHh","chartCard":"PO1cm","rankCard":"V2jnc","bottomRow":"RpvHM"};